var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"z-card"},[_c('div',{staticClass:"z-card-title"},[_vm._t("header",function(){return [_c('div',{staticClass:"title-text"},[_c('span',{style:(_vm.titleCss)},[_vm._v(_vm._s(_vm.title))])]),_vm._t("right")]})],2),_c('div',{staticClass:"z-card-content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }